<template>
  <div class="ChatBox">
    <button
      class="ChatBox__button"
      :class="{
        'has-avatar': Boolean(avatar),
        'is-visible': visible
      }"
      @click="togglePreChat"
      v-if="!visible || !ismobile"
      aria-label="Abrir suporte via chat"
    >
      <div class="ChatBox__image" v-if="!visible">
        <span
          v-if="avatar"
          :style="`background-image: url(${avatar})`"
          class="ChatBox__avatar"
        />
        <svg
          v-else
          class="ChatBox__icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 60 60"
        >
          <path
            d="M54 2.5H6c-3.252 0-6 2.748-6 6v33c0 3.252 2.748 6 6 6h14.555l8.702 9.67c.19.21.46.33.743.33s.554-.12.743-.33l8.702-9.67H54c3.252 0 6-2.748 6-6v-33c0-3.252-2.748-6-6-6zm-42 13h15c.553 0 1 .448 1 1s-.447 1-1 1H12c-.553 0-1-.448-1-1s.447-1 1-1zm34 18H12c-.553 0-1-.448-1-1s.447-1 1-1h34c.553 0 1 .448 1 1s-.447 1-1 1zm0-8H12c-.553 0-1-.448-1-1s.447-1 1-1h34c.553 0 1 .448 1 1s-.447 1-1 1z"
          />
        </svg>
      </div>
      <template v-if="visible">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            fill="#fff"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </template>
    </button>
    <div ref="messages" class="ChatBox__container">
      <div class="ChatBox__message">
        <slot />
      </div>
    </div>
    <span class="ChatBox__shadow"></span>
  </div>
</template>

<script>
export default {
  name: "chatbox",
  data() {
    return {
      visible: false
    };
  },
  props: {
    avatar: {
      default: "",
      type: String
    }
  },
  computed: {
    ismobile() {
      return this.$store.state.ismobile;
    }
  },
  methods: {
    togglePreChat() {
      this.preChat = !this.preChat;
      if (this.preChat) {
        this.$nextTick(() => {
          this.$refs.messages.classList.add("is-visible");
          this.visible = true;
          this.$emit("open");
        });
      } else {
        this.$refs.messages.classList.remove("is-visible");
        this.visible = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.ChatBox
  & > .ChatBox__button
    transform scale(1)
    opacity 1
    pointer-events auto
  & > .ChatBox__button
    &:hover
      transform scale(1.05)
      box-shadow 0 4px 42px 0 rgba(0,0,0,.25)
    &:active
      transform scale(0.95)
.ChatBox__message
  /*margin-bottom 1rem*/
  margin-bottom 0
  & > p
    margin-bottom 1rem
.ChatBox__container
  width 100%
  position fixed
  top 0
  bottom 0
  left 0
  right 0
  box-shadow 0 12px 40px 0 rgba(0,0,0,.175)
  z-index 9999
  background rgb(255, 255, 255)
  border-radius 4px
  opacity 0
  transform translateY(30px)
  pointer-events none
  transition transform 0.15s, opacity 0.15s
  font-size 0.9rem
  /*animation slideUpAndFade 0.3s ease-in-out forwards*/
  &.is-visible
    opacity 1
    transform translateY(0)
    pointer-events auto
  & > p
    margin-bottom 1rem
.ChatBox__shadow
  content ''
  background-image radial-gradient(center center, #000 0, transparent 100%) !important
  pointer-events none
  position fixed
  right -50vw
  bottom -50vh
  height 100vh
  width 100vw
  opacity 0
  z-index 0
  transition opacity 0.3s
.ChatBox__button
  display flex
  align-items center
  justify-content center
  width 48px
  height 48px
  border-radius 100%
  background #292929
  position fixed
  bottom 20px
  right 25px
  z-index 9999999
  border none
  outline 0
  cursor pointer
  box-shadow 0 4px 32px 0 rgba(0,0,0,.175)
  transition transform 0.15s, box-shadow .15s, opacity 0.15s
  transform scale(0.6)
  opacity 0
  pointer-events none
  padding 0
  overflow hidden
  &.has-avatar:not(.is-visible)
    background none
.ChatBox__icon
  fill rgba(255, 255, 255, 1)
  height 20px
.ChatBox__image
  line-height 0
  height 61px
  width 61px
  display inherit
  justify-content inherit
  align-items inherit
.ChatBox__avatar
  height inherit
  width inherit
  background-size cover
@media screen and (min-width 560px)
  .ChatBox__container
    max-width 320px
    bottom 100px
    top auto
    right 24px
    left auto
  .ChatBox__button
    width 56px
    height 56px
  .ChatBox__icon
    height 22px
@media screen and (min-width 640px)
  .ChatBox__container
    max-width 360px
  .ChatBox__button
    width 60px
    height 60px
  .ChatBox__icon
    height 24px
@media screen and (min-width 780px)
  .ChatBox__container
    max-width 400px
  .ChatBox__icon
    height 28px

@keyframes slideUpAndFade
  0%
    transform translateY(30px)
    opacity 0
  100%
    transform translateY(0)
    opacity 1
</style>
